import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import LayoutRenderer from './LayoutRenderer'

class LayoutRoute extends Component {
  render () {
    return (
      <Route path={this.props.path} render={(props) => (
        <LayoutRenderer {...props} dataType={this.props.dataType} />
      )} />
    )
  }
}

LayoutRoute.propTypes = {
  path: PropTypes.string,
  dataType: PropTypes.string
}

export default LayoutRoute



// WEBPACK FOOTER //
// ./src/components/LayoutRoute.js